import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO, ADDRESS, PHONE_DISPLAY } from "@/lib/site";

export default function Privacidade() {
  return (
    <div className="min-h-screen bg-ink text-white">
      <header className="border-b border-white/10">
        <div className="container-x h-20 flex items-center justify-between">
          <Link to="/"><img src={LOGO} alt="DG Guinchos Jundiaí" className="h-12 w-auto" /></Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-zinc-300 hover:text-brand">
            <ArrowLeft className="h-4 w-4" /> Voltar ao site
          </Link>
        </div>
      </header>

      <main className="container-x py-16 max-w-3xl">
        <h1 className="font-display text-4xl md:text-5xl font-black">Política de Privacidade</h1>
        <p className="mt-3 text-zinc-500">Última atualização: {new Date().toLocaleDateString("pt-BR")}</p>

        <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl font-bold text-white">1. Quem somos</h2>
            <p className="mt-3">A DG Guinchos Jundiaí presta serviços de guincho, reboque e transporte de veículos em Jundiaí e região. Endereço: {ADDRESS.street} - {ADDRESS.district}, {ADDRESS.city}, CEP {ADDRESS.zip}. Telefone: {PHONE_DISPLAY}.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-bold text-white">2. Dados que coletamos</h2>
            <p className="mt-3">Ao utilizar nosso formulário de solicitação de atendimento, podemos coletar nome, telefone, dados do veículo e localização informada. Esses dados são utilizados exclusivamente para prestar o atendimento solicitado e entrar em contato com você.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-bold text-white">3. Uso das informações</h2>
            <p className="mt-3">As informações fornecidas são usadas para responder solicitações, agendar e realizar o atendimento de guincho e transporte. Não vendemos nem compartilhamos seus dados com terceiros para fins de marketing.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-bold text-white">4. Cookies e medição</h2>
            <p className="mt-3">Este site pode utilizar ferramentas de medição (como Google Analytics e Google Ads) para entender o desempenho e melhorar o atendimento. Você pode gerenciar cookies nas configurações do seu navegador.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-bold text-white">5. Seus direitos</h2>
            <p className="mt-3">De acordo com a LGPD (Lei nº 13.709/2018), você pode solicitar acesso, correção ou exclusão dos seus dados a qualquer momento entrando em contato pelo telefone {PHONE_DISPLAY}.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl font-bold text-white">6. Contato</h2>
            <p className="mt-3">Em caso de dúvidas sobre esta Política de Privacidade, entre em contato pelo telefone/WhatsApp {PHONE_DISPLAY}.</p>
          </section>
        </div>
      </main>
    </div>
  );
}
